import React from 'react'
import axios from "axios"
import '../index.js'

import Tabletop from 'tabletop'
import point_trophy from './asset/point_trophy.png'
import first_medal from './asset/first_medal.png'
import second_medal from'./asset/second_medal.png'
import third_medal from './asset/third_medal.png'
import no_medal from './asset/no_medal.png'

const Batsman = props => (
    
    <tr>
        <td>{props.player.ID}</td>
        <td>{props.player.Name}</td>
        <td>{props.player.Team}</td>   
        <td>{props.player.Runs}</td>    
        <td>{props.player.Matches}</td>
        <td><img src={props.player.medal} height= "30" width = "20" style = {{margin : 5}}/> {props.player.Ranking}</td>
        <td><img src={point_trophy} height= "30" width = "30" style = {{margin : 5}}/>
            {props.player.Points}</td>
        
    </tr>
)


const Bowler = props => (
    
    <tr>
        <td>{props.player.ID}</td>
        <td>{props.player.Name}</td>
        <td>{props.player.Team}</td>   
        <td>{props.player.Wickets}</td>    
        <td>{props.player.Matches}</td>
        <td><img src={props.player.medal} height= "30" width = "20" style = {{margin : 5}}/> {props.player.Ranking}</td>
        <td><img src={point_trophy} height= "30" width = "30" style = {{margin : 5}}/>
            {props.player.Points}</td>
        
    </tr>
)
const Keeper = props => (
    
    <tr>
        <td>{props.player.ID}</td>
        <td>{props.player.Name}</td>
        <td>{props.player.Team}</td>   
        <td>{props.player.Dissmissal}</td>    
        <td>{props.player.Matches}</td>
        <td><img src={props.player.medal} height= "30" width = "20" style = {{margin : 5}}/> {props.player.Ranking}</td>
        <td><img src={point_trophy} height= "30" width = "30" style = {{margin : 5}}/>
            {props.player.Points}</td>
        
    </tr>
)
const Allrounder = props => (

    
    <tr>
        <td>{props.player.ID}</td>
        <td>{props.player.Name}</td>
        <td>{props.player.Team}</td>  
        <td>{props.player.Runs}</td>   
        <td>{props.player.Wickets}</td>    
        <td>{props.player.Matches}</td>
        <td><img src={props.player.medal} height= "30" width = "20" style = {{margin : 5}}/> {props.player.Ranking}</td>
        <td><img src={point_trophy} height= "30" width = "30" style = {{margin : 5}}/>
            {props.player.Points}</td>
        
    </tr>
)
// const requestBtmn = axios.get('http://localhost:4000/registration_data/btmn');
// const requestBowler = axios.get('http://localhost:4000/registration_data/bowler');

class Results extends React.Component {
    constructor() {
        super();
        this.state = {
            batsman : [],
            bowler : [],
            keeper: [],
            allrounder: []
        }
    }
    
    componentDidMount() {
            Tabletop.init({
                key: '1gUczpNwOE_ln9dp4SynGGPPDrDq8xovxpLgj_7bzjCk',
                callback: responseBtmn => {
                   
                    let resultBtmn = responseBtmn.map((myplayer) => {
                                if (myplayer.Ranking === "1") {
                                    myplayer.medal = first_medal }
                                else if (myplayer.Ranking === "2") { myplayer.medal = second_medal }
                                else if (myplayer.Ranking === "3") { myplayer.medal = third_medal }
                                else { myplayer.medal = no_medal }
                                return myplayer
                            })
                            this.setState({batsman: resultBtmn})
                            
                },
                simpleSheet: true
            })
            .then(Tabletop.init({
                key: '1sXVeep_0ddHi8cY4UWD49wKh3hsKHl2VTf5nrSOSvD8',
                callback: responseBowler => {
                   
                    let resultBowler = responseBowler.map((myplayer) => {
                                if (myplayer.Ranking === "1") { myplayer.medal = first_medal }
                                else if (myplayer.Ranking === "2") { myplayer.medal = second_medal }
                                else if (myplayer.Ranking === "3") { myplayer.medal = third_medal }
                                else { myplayer.medal = no_medal }
                                return myplayer
                            })
                            this.setState({bowler: resultBowler})
                },
                simpleSheet: true
            }))
            .then(Tabletop.init({
                key: '1LiXIuHTWuan_v--GhCmVknDl21nmDDskzKBK75ljbCw',
                callback: responseKeeper => {
              
                    let resultKeeper = responseKeeper.map((myplayer) => {
                                if (myplayer.Ranking === "1") { myplayer.medal = first_medal }
                                else if (myplayer.Ranking === "2") { myplayer.medal = second_medal }
                                else if (myplayer.Ranking === "3") { myplayer.medal = third_medal }
                                else { myplayer.medal = no_medal }
                                return myplayer
                            })
                            this.setState({keeper: resultKeeper})
                },
                simpleSheet: true
            }))
            .then(Tabletop.init({
                key: '1ZI4-KSYKsCxYjISpttYTpL_-ESC2K4pCQnBPChimwE8',
                callback: responseAllrounder => {
                   
                    let resultAllrounder = responseAllrounder.map((myplayer) => {
                                if (myplayer.Ranking === "1") { myplayer.medal = first_medal }
                                else if (myplayer.Ranking === "2") { myplayer.medal = second_medal }
                                else if (myplayer.Ranking === "3") { myplayer.medal = third_medal }
                                else { myplayer.medal = no_medal }
                                return myplayer
                            })
                            this.setState({allrounder: resultAllrounder})
                },
                simpleSheet: true
            }))
            .catch((err) => {
                console.log(err)
            })

        // axios.all([requestBtmn, requestBowler])
        // .then(axios.spread((...responses) => {
        //     const responseBtmn = responses[0]
        //     const responseBowler = responses[1]
        //     let resultBtmn = responseBtmn.data.map((myplayer) => {
        //         if (myplayer.Ranking === 1) { myplayer.medal = first_medal }
        //         else if (myplayer.Ranking === 2) { myplayer.medal = second_medal }
        //         else if (myplayer.Ranking === 3) { myplayer.medal = third_medal }
        //         else { myplayer.medal = no_medal }
        //         return myplayer
        //     })
        //     this.setState({batsman: resultBtmn})

        //     let resultBowler = responseBowler.data.map((myplayer) => {
        //         if (myplayer.Ranking === 1) { myplayer.medal = first_medal }
        //         else if (myplayer.Ranking === 2) { myplayer.medal = second_medal }
        //         else if (myplayer.Ranking === 3) { myplayer.medal = third_medal }
        //         else { myplayer.medal = no_medal }
        //         return myplayer
        //     })
        //     this.setState({bowler: resultBowler})

        //     console.log(responseBtmn,responseBowler)
        // })
        // )
        // .catch((err) => {
        //     console.log(err)
        // })
    }
    batsmanList() {
        return this.state.batsman.map((currentPlayer, i) => {
            return <Batsman player = {currentPlayer} key={i} />
        })
    }
    bowlerList() {
        
        return this.state.bowler.map((currentPlayer, i) => {
            return <Bowler player = {currentPlayer} key={i} />
        })
    }
    keeperList() {
        
        return this.state.keeper.map((currentPlayer, i) => {
            return <Keeper player = {currentPlayer} key={i} />
        })
    }
    allrounderList() {
        
        return this.state.allrounder.map((currentPlayer, i) => {
            return <Allrounder player = {currentPlayer} key={i} />
        })
    }
    render() {
        return (
            <div className = "results">
                <div className="card border-0 shadow my-5">
                <div className="card-body p-5">
                <h4 className="text-muted">BATSMAN RANKING</h4>
                <div className = "table-responsive border-lg" >
                <table className="table table-striped table-hover table-bordered " style={{ marginTop: 20 }} >
                    <thead className="thead thead-dark">
                        <tr>
                            <th>UNIQUE_ID</th>
                            <th >NAME</th>
                            <th >TEAM</th>
                            <th >RUNS</th>
                            <th >MATCHES</th>
                            <th >RANK</th>
                            <th >POINTS</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        { this.batsmanList() }
                    </tbody>
                </table>
               </div>
               </div>
               </div>
               <hr></hr>
               <div className="card border-0 shadow my-5 ">
                <div className="card-body p-5">
               <h4 className="text-muted">BOWLER RANKING</h4>
               <div className = "table-responsive border-lg" >
                <table className="table table-striped table-hover table-bordered " style={{ marginTop: 20 }} >
                    <thead className="thead thead-dark">
                        <tr>
                            <th>UNIQUE_ID</th>
                            <th >NAME</th>
                            <th >TEAM</th>
                            <th >WICKETS</th>
                            <th >MATCHES</th>
                            <th >RANK</th>
                            <th >POINTS</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        { this.bowlerList() }
                    </tbody>
                </table>
               </div>
               </div>
               </div>
               <div className="card border-0 shadow my-5 ">
                <div className="card-body p-5">
               <h4 className="text-muted">KEEPER RANKING</h4>
               <div className = "table-responsive border-lg" >
                <table className="table table-striped table-hover table-bordered " style={{ marginTop: 20 }} >
                    <thead className="thead thead-dark">
                        <tr>
                            <th>UNIQUE_ID</th>
                            <th >NAME</th>
                            <th >TEAM</th>
                            <th >DISSMISSAL</th>
                            <th >MATCHES</th>
                            <th >RANK</th>
                            <th >POINTS</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        { this.keeperList() }
                    </tbody>
                </table>
               </div>
               </div>
               </div>
               <div className="card border-0 shadow my-5 ">
                <div className="card-body p-5">
               <h4 className="text-muted">ALLROUNDER RANKING</h4>
               <div className = "table-responsive border-lg" >
                <table className="table table-striped table-hover table-bordered " style={{ marginTop: 20 }} >
                    <thead className="thead thead-dark">
                        <tr>
                            <th>UNIQUE_ID</th>
                            <th >NAME</th>
                            <th >TEAM</th>
                            <th >RUNS</th>
                            <th >WICKETS</th>
                            <th >MATCHES</th>
                            <th >RANK</th>
                            <th >POINTS</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        { this.allrounderList() }
                    </tbody>
                </table>
               </div>
               </div>
               </div>
            </div>
        )
    }
}


export default Results;